module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true,
      "customEventName": "customstatechangedeventname"
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      },
      "statechanged": function($event) {
        return _vm.playerStateChanged($event)
      },
      "ready": _vm.playerReadied,
      "error": function($event) {
        return _vm.error($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a58dee0a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 84
// module chunks = 8 9 10 11 16 17